/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_P3Inputs */

const et_about_p3 = /** @type {(inputs: About_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meie missioon on sirgejooneline: skaleerida sinu äri päringuid ja müüki. Me teeme seda kodulehe konversioonide optimeerimise, halastamatu SEO, AI sotsiaalmeedia ja automatsioonidega. Las tulemused räägivad enda eest.`)
};

const en_about_p3 = /** @type {(inputs: About_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our mission is straightforward: scale your business inquiries and sales. We do it through website conversion optimization, relentless SEO, AI social media, and automation. Let the results speak for themselves.`)
};

/**
* | output |
* | --- |
* | "Our mission is straightforward: scale your business inquiries and sales. We do it through website conversion optimization, relentless SEO, AI social media, a..." |
*
* @param {About_P3Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const about_p3 = /** @type {((inputs?: About_P3Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_P3Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_about_p3(inputs)
	return en_about_p3(inputs)
});